// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Close icon in top right corner - positioned relative to content body */
.FF-ManagePermissions-closeIcon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
}

/* Content body - this will be the positioning context for close button */
.FF-ManagePermissions-contentBody {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 25rem;
  max-height: calc(100dvh - 2rem);
  padding: 1.5rem;
  background: var(--color-background-neutral-subtlest, #ffffff);
  border-radius: var(--border-radius-xs, 0.25rem);
  overflow-y: auto;
}

.FF-ManagePermissions-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Header */
.FF-ManagePermissions-heading {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
}

.FF-ManagePermissions-infoBanner {
  margin-top: 0.5rem;
}

.FF-ManagePermissions-infoBanner [class*='AlertBanner-icon'] {
  padding: 0;
  align-items: center;
}

.FF-ManagePermissions-infoBanner [class*='AlertBanner-icon'] svg {
  height: 1.5rem;
  width: 1.5rem;
}

.FF-ManagePermissions-selectedHeader {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
}
.FF-ShareList-sectionHeading {
  width: 100%;
}

.FF-ManagePermissions-selectLabel {
  padding-bottom: 0.5rem;
}

/* Selection section */
.FF-ManagePermissions-selectionsWrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.FF-ManagePermissions-optionSelect,
.FF-ManagePermissions-selectedOptions {
  padding: 0.875rem;
  border-radius: var(--border-radius-sm, 0.5rem);
}
.FF-ManagePermissions-optionSelect {
  background: var(--color-background-secondary-subtlest, #f7f9fc);
}
.FF-ManagePermissions-selectedOptions {
  background: var(--color-background-success-subtlest, #f3f8f2);
}

/* Footer */
.FF-ManagePermissions-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/features/FormManagement/components/FormActionModal/ManagePermissions/ManagePermissions.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,6DAA6D;EAC7D,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,+DAA+D;AACjE;AACA;EACE,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* Close icon in top right corner - positioned relative to content body */\n.FF-ManagePermissions-closeIcon {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 2;\n}\n\n/* Content body - this will be the positioning context for close button */\n.FF-ManagePermissions-contentBody {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 25rem;\n  max-height: calc(100dvh - 2rem);\n  padding: 1.5rem;\n  background: var(--color-background-neutral-subtlest, #ffffff);\n  border-radius: var(--border-radius-xs, 0.25rem);\n  overflow-y: auto;\n}\n\n.FF-ManagePermissions-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Header */\n.FF-ManagePermissions-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  width: 100%;\n}\n\n.FF-ManagePermissions-infoBanner {\n  margin-top: 0.5rem;\n}\n\n.FF-ManagePermissions-infoBanner [class*='AlertBanner-icon'] {\n  padding: 0;\n  align-items: center;\n}\n\n.FF-ManagePermissions-infoBanner [class*='AlertBanner-icon'] svg {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.FF-ManagePermissions-selectedHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.FF-ShareList-sectionHeading {\n  width: 100%;\n}\n\n.FF-ManagePermissions-selectLabel {\n  padding-bottom: 0.5rem;\n}\n\n/* Selection section */\n.FF-ManagePermissions-selectionsWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.FF-ManagePermissions-optionSelect,\n.FF-ManagePermissions-selectedOptions {\n  padding: 0.875rem;\n  border-radius: var(--border-radius-sm, 0.5rem);\n}\n.FF-ManagePermissions-optionSelect {\n  background: var(--color-background-secondary-subtlest, #f7f9fc);\n}\n.FF-ManagePermissions-selectedOptions {\n  background: var(--color-background-success-subtlest, #f3f8f2);\n}\n\n/* Footer */\n.FF-ManagePermissions-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
